import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-486ba4e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "mb-10" }
const _hoisted_7 = { class: "text-muted fs-6" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table table-striped table-hover" }
const _hoisted_10 = { class: "fw-bold" }
const _hoisted_11 = { class: "px-4 min-w-300px text-start" }
const _hoisted_12 = { class: "px-4 min-w-150px text-end" }
const _hoisted_13 = { class: "px-4 min-w-150px text-end" }
const _hoisted_14 = { class: "px-4 min-w-150px text-end" }
const _hoisted_15 = { class: "align-middle" }
const _hoisted_16 = { class: "fw-semibold" }
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = { class: "text-end" }
const _hoisted_19 = { class: "align-middle text-end" }
const _hoisted_20 = { class: "fw-semibold" }
const _hoisted_21 = { class: "align-middle" }
const _hoisted_22 = { class: "fw-semibold" }
const _hoisted_23 = { class: "text-end" }
const _hoisted_24 = { class: "text-end" }
const _hoisted_25 = { class: "align-middle text-end" }
const _hoisted_26 = { class: "fw-semibold" }
const _hoisted_27 = { class: "align-middle" }
const _hoisted_28 = { class: "fw-semibold" }
const _hoisted_29 = { class: "text-end" }
const _hoisted_30 = { class: "text-end" }
const _hoisted_31 = { class: "align-middle text-end" }
const _hoisted_32 = { class: "fw-semibold" }
const _hoisted_33 = { class: "align-middle" }
const _hoisted_34 = { class: "fw-semibold" }
const _hoisted_35 = { class: "text-end" }
const _hoisted_36 = { class: "text-end" }
const _hoisted_37 = { class: "align-middle text-end" }
const _hoisted_38 = { class: "fw-semibold" }
const _hoisted_39 = { class: "align-middle" }
const _hoisted_40 = { class: "fw-semibold" }
const _hoisted_41 = { class: "text-end" }
const _hoisted_42 = { class: "text-end" }
const _hoisted_43 = { class: "align-middle text-end" }
const _hoisted_44 = { class: "fw-semibold" }
const _hoisted_45 = { class: "table-active fw-bold" }
const _hoisted_46 = { class: "align-middle" }
const _hoisted_47 = { class: "fw-bold" }
const _hoisted_48 = { class: "text-end" }
const _hoisted_49 = { class: "fw-bold" }
const _hoisted_50 = { class: "text-end" }
const _hoisted_51 = { class: "fw-bold" }
const _hoisted_52 = { class: "text-end" }
const _hoisted_53 = { class: "fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_CurrencyInput = _resolveComponent("CurrencyInput")!
  const _component_Page = _resolveComponent("Page")!

  return (_openBlock(), _createBlock(_component_Page, { showBack: "" }, {
    actions: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.onSubmit,
        loading: _ctx.isLoading,
        disabled: _ctx.isLoading
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("formularios.profesionalDetalle.guardar.button")), 1)
        ]),
        _: 1
      }, 8, ["onClick", "loading", "disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("menu.justificacion2025")), 1)
          ])
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("formularios.justificacion2025.instrucciones")), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("table", _hoisted_9, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_10, [
                    _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.comarcaNombre), 1),
                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("formularios.justificacion2025.creditoComprometido")), 1),
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("formularios.justificacion2025.creditoEjecutado")), 1),
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t(
                        "formularios.justificacion2025.creditoComprometidoNoEjecutado"
                      )), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("formularios.justificacion2025.linea1")), 1)
                    ]),
                    _createElementVNode("td", _hoisted_17, [
                      (_openBlock(), _createBlock(_component_CurrencyInput, {
                        key: `l1-comprometido-${_ctx.dataLoadKey}`,
                        modelValue: _ctx.l1CreditoComprometido,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.l1CreditoComprometido) = $event)),
                        options: _ctx.currencyOptions,
                        "data-test": "l1-comprometido"
                      }, null, 8, ["modelValue", "options"]))
                    ]),
                    _createElementVNode("td", _hoisted_18, [
                      (_openBlock(), _createBlock(_component_CurrencyInput, {
                        key: `l1-ejecutado-${_ctx.dataLoadKey}`,
                        modelValue: _ctx.l1CreditoEjecutado,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.l1CreditoEjecutado) = $event)),
                        options: _ctx.currencyOptions,
                        "data-test": "l1-ejecutado"
                      }, null, 8, ["modelValue", "options"]))
                    ]),
                    _createElementVNode("td", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.formatCurrency(_ctx.creditoNoEjecutado.l1)), 1)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("formularios.justificacion2025.linea2")), 1)
                    ]),
                    _createElementVNode("td", _hoisted_23, [
                      (_openBlock(), _createBlock(_component_CurrencyInput, {
                        key: `l2-comprometido-${_ctx.dataLoadKey}`,
                        modelValue: _ctx.l2CreditoComprometido,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.l2CreditoComprometido) = $event)),
                        options: _ctx.currencyOptions,
                        "data-test": "l2-comprometido"
                      }, null, 8, ["modelValue", "options"]))
                    ]),
                    _createElementVNode("td", _hoisted_24, [
                      (_openBlock(), _createBlock(_component_CurrencyInput, {
                        key: `l2-ejecutado-${_ctx.dataLoadKey}`,
                        modelValue: _ctx.l2CreditoEjecutado,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.l2CreditoEjecutado) = $event)),
                        options: _ctx.currencyOptions,
                        "data-test": "l2-ejecutado"
                      }, null, 8, ["modelValue", "options"]))
                    ]),
                    _createElementVNode("td", _hoisted_25, [
                      _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.formatCurrency(_ctx.creditoNoEjecutado.l2)), 1)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_27, [
                      _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("formularios.justificacion2025.linea3")), 1)
                    ]),
                    _createElementVNode("td", _hoisted_29, [
                      (_openBlock(), _createBlock(_component_CurrencyInput, {
                        key: `l3-comprometido-${_ctx.dataLoadKey}`,
                        modelValue: _ctx.l3CreditoComprometido,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.l3CreditoComprometido) = $event)),
                        options: _ctx.currencyOptions,
                        "data-test": "l3-comprometido"
                      }, null, 8, ["modelValue", "options"]))
                    ]),
                    _createElementVNode("td", _hoisted_30, [
                      (_openBlock(), _createBlock(_component_CurrencyInput, {
                        key: `l3-ejecutado-${_ctx.dataLoadKey}`,
                        modelValue: _ctx.l3CreditoEjecutado,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.l3CreditoEjecutado) = $event)),
                        options: _ctx.currencyOptions,
                        "data-test": "l3-ejecutado"
                      }, null, 8, ["modelValue", "options"]))
                    ]),
                    _createElementVNode("td", _hoisted_31, [
                      _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.formatCurrency(_ctx.creditoNoEjecutado.l3)), 1)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_33, [
                      _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t("formularios.justificacion2025.linea4")), 1)
                    ]),
                    _createElementVNode("td", _hoisted_35, [
                      (_openBlock(), _createBlock(_component_CurrencyInput, {
                        key: `l4-comprometido-${_ctx.dataLoadKey}`,
                        modelValue: _ctx.l4CreditoComprometido,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.l4CreditoComprometido) = $event)),
                        options: _ctx.currencyOptions,
                        "data-test": "l4-comprometido"
                      }, null, 8, ["modelValue", "options"]))
                    ]),
                    _createElementVNode("td", _hoisted_36, [
                      (_openBlock(), _createBlock(_component_CurrencyInput, {
                        key: `l4-ejecutado-${_ctx.dataLoadKey}`,
                        modelValue: _ctx.l4CreditoEjecutado,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.l4CreditoEjecutado) = $event)),
                        options: _ctx.currencyOptions,
                        "data-test": "l4-ejecutado"
                      }, null, 8, ["modelValue", "options"]))
                    ]),
                    _createElementVNode("td", _hoisted_37, [
                      _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.formatCurrency(_ctx.creditoNoEjecutado.l4)), 1)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_39, [
                      _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t("formularios.justificacion2025.linea5")), 1)
                    ]),
                    _createElementVNode("td", _hoisted_41, [
                      (_openBlock(), _createBlock(_component_CurrencyInput, {
                        key: `l5-comprometido-${_ctx.dataLoadKey}`,
                        modelValue: _ctx.l5CreditoComprometido,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.l5CreditoComprometido) = $event)),
                        options: _ctx.currencyOptions,
                        "data-test": "l5-comprometido"
                      }, null, 8, ["modelValue", "options"]))
                    ]),
                    _createElementVNode("td", _hoisted_42, [
                      (_openBlock(), _createBlock(_component_CurrencyInput, {
                        key: `l5-ejecutado-${_ctx.dataLoadKey}`,
                        modelValue: _ctx.l5CreditoEjecutado,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.l5CreditoEjecutado) = $event)),
                        options: _ctx.currencyOptions,
                        "data-test": "l5-ejecutado"
                      }, null, 8, ["modelValue", "options"]))
                    ]),
                    _createElementVNode("td", _hoisted_43, [
                      _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.formatCurrency(_ctx.creditoNoEjecutado.l5)), 1)
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_45, [
                    _createElementVNode("td", _hoisted_46, [
                      _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.$t("formularios.justificacion2025.total")), 1)
                    ]),
                    _createElementVNode("td", _hoisted_48, [
                      _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.formatCurrency(_ctx.totalComprometido)), 1)
                    ]),
                    _createElementVNode("td", _hoisted_50, [
                      _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.formatCurrency(_ctx.totalEjecutado)), 1)
                    ]),
                    _createElementVNode("td", _hoisted_52, [
                      _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.formatCurrency(_ctx.totalComprometidoNoEjecutado)), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ], 32)
      ])
    ]),
    _: 1
  }))
}